export default (function () {
  // Header Menu
  $('.toggle-menu').click(function (e) {
    $('body').toggleClass('open-nav');
  });
  $('.open-sub-menu').click(function (e) {
    $(this).parents('li').toggleClass('sub-menu-opened');
  });
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 10) {
      $('header').addClass("small");
    } else {
      $('header').removeClass("small");
    }
  });
});